// extracted by mini-css-extract-plugin
module.exports = {"section-wrapper":"transcription-section__section-wrapper___2zA6X"};